// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventTeamScheduleGetBody = {
  teamId: string;
  seasonId: string;
  timeZone: string;
};

export type typeEventTeamScheduleGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    seasonId: string;
    timeZone: string;
    events: {
      eventId: string;
      leagueId: string;
      seasonId: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      statusLabel: string;
      statusDetail?: string | null;
      isLive: boolean;
      isKickoffPassed: boolean;
      winnerTeamId?: string | null;
      isTie: boolean;
      home: {
        teamId: string;
        name: string;
        abbreviation: string;
        logoMediaId?: string | null;
        primaryColorHex?: string | null;
        score?: number | null;
        recordLabel?: string | null;
        logoUrl?: string | null;
        shortName?: string | null;
      };
      away: {
        teamId: string;
        name: string;
        abbreviation: string;
        logoMediaId?: string | null;
        primaryColorHex?: string | null;
        score?: number | null;
        recordLabel?: string | null;
        logoUrl?: string | null;
        shortName?: string | null;
      };
      liveState?: {
        possessionTeamId?: string | null;
        baseball?: {
          balls: number;
          strikes: number;
          outs: number;
          isFirstOccupied: boolean;
          isSecondOccupied: boolean;
          isThirdOccupied: boolean;
          countLabel: string;
          outsLabel: string;
          pitcher?: { name: string; lineLabel: string | null } | null;
          batter?: { name: string; lineLabel: string | null } | null;
        } | null;
        football?: {
          ballSpotLabel: string;
          ballSpotPercentFromAway: number;
          firstDownPercentFromAway?: number | null;
          driveStartPercentFromAway?: number | null;
          driveSummaryLabel?: string | null;
        } | null;
        summaryLabel: string;
        downAndDistanceLabel?: string | null;
        hockey?: { powerPlayTeamId: string; powerPlayLabel: string } | null;
      } | null;
    }[];
    refreshAfterSeconds: number;
  };
};

export type typeEventTeamScheduleGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventTeamScheduleGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventTeamScheduleGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventTeamScheduleGetBody = {
  type: "object",
  properties: {
    teamId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonId: { type: "string", maxLength: 3000, minLength: 1 },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["teamId", "seasonId", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventTeamScheduleGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventTeamScheduleGetBody);
  }

  return async function postEventTeamScheduleGet(
    payload: typeEventTeamScheduleGetBody,
  ): Promise<
    typeEventTeamScheduleGetOutput200 | typeEventTeamScheduleGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventTeamScheduleGet" failed before calling the network. #2c21708b9315`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#2c21708b9315" },
        },
        data: null,
      } as typeEventTeamScheduleGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/team-schedule-get`,
      httpMethod: "POST",
      options,
    })) as
      typeEventTeamScheduleGetOutput200 | typeEventTeamScheduleGetOutput400;
  };
}
